let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("afHt5")).then(() => parcelRequire('1FuKj'));